import { useTranslation } from 'react-i18next';

export default function CampusSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('facilities.campus.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('facilities.campus.title')}
          </h2>
          {String(t('facilities.campus.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-start">
          <div className="flex-1 space-y-5">
            {['p1', 'p2', 'p3'].map((key) => (
              <p
                key={key}
                className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-[2.2]"
              >
                {t(`facilities.campus.${key}`)}
              </p>
            ))}
          </div>

          <div className="flex-1 flex-shrink-0">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="/images/generated/tjba26_b12_lecture_table_listening.jpg"
                alt={t('facilities.campus.imgAlt')}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
